var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMagmaLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 32,
    viewBox: "0 0 59 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8694 2.0429C16.7625 0.500242 18.7967 0.0993848 20.3843 0.909767C26.1021 3.8283 32.8968 3.8283 38.6146 0.909768C40.2022 0.0993856 42.2364 0.500241 43.1295 2.0429L57.901 27.5595C58.8845 29.2584 57.0745 31.2043 55.3089 30.3462L52.8496 29.1508C48.3775 26.9772 43.155 26.9772 38.6829 29.1508C32.8849 31.969 26.1139 31.969 20.3159 29.1508C15.8438 26.9772 10.6213 26.9772 6.14921 29.1508L3.69001 30.3461C1.92444 31.2043 0.114441 29.2584 1.09795 27.5595L15.8694 2.0429Z",
    fill: "url(#paint0_linear_1137_28323)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2034 1.26415L20.384 0.910455L20.2034 1.26415C18.766 0.530465 16.9806 0.917635 16.2138 2.24224L1.44229 27.7588C0.655437 29.118 2.10352 30.6748 3.51608 29.9883L5.97528 28.793C10.5572 26.566 15.9079 26.566 20.4898 28.793C26.1781 31.5577 32.8208 31.5577 38.509 28.793C43.0909 26.566 48.4416 26.566 53.0235 28.793L55.4829 29.9883C56.8954 30.6749 58.3435 29.1181 57.5566 27.7588L42.7851 2.24224C42.0183 0.917635 40.2329 0.530466 38.7955 1.26415C32.9641 4.24068 26.0348 4.24068 20.2034 1.26415Z",
    stroke: "url(#paint1_linear_1137_28323)",
    strokeOpacity: 0.2,
    strokeWidth: 0.795755
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.953 15.2579C32.782 7.75885 34.0203 5.13927 38.8089 1.20162C40.1857 0.0694914 42.2364 0.500966 43.1295 2.04362L57.901 27.5602C58.8845 29.2592 57.0745 31.205 55.3089 30.3469L52.8496 29.1516C48.3775 26.9779 43.155 26.9779 38.6829 29.1516C32.8849 31.9697 26.1139 31.9697 20.3159 29.1516C15.8438 26.9779 10.6213 26.9779 6.14921 29.1516L3.69001 30.3468C1.92444 31.205 0.114441 29.2591 1.09795 27.5602L8.78565 14.2803C8.78565 14.2803 24.5012 23.9766 28.953 15.2579Z",
    fill: "url(#paint2_linear_1137_28323)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0616 1.50894C34.5008 5.25926 33.2222 7.76543 29.6792 14.7101C29.558 14.9477 29.4341 15.1905 29.3074 15.4388C28.1264 17.7518 26.1866 18.844 23.9832 19.1767C21.8002 19.5064 19.3531 19.0942 17.0865 18.4199C14.8137 17.7439 12.6875 16.7936 11.1326 16.0148C10.3542 15.625 9.71699 15.277 9.27366 15.0262C9.14066 14.9509 9.02507 14.8843 8.92832 14.828L1.44229 27.7595C0.655437 29.1188 2.10352 30.6756 3.51608 29.989L5.97528 28.7937C10.5572 26.5667 15.9079 26.5667 20.4898 28.7937C26.1781 31.5585 32.8208 31.5585 38.509 28.7937C43.0909 26.5667 48.4416 26.5667 53.0235 28.7937L55.4829 29.989C56.8954 30.6756 58.3435 29.1188 57.5566 27.7596L42.7851 2.24296C42.0075 0.899723 40.2372 0.542275 39.0616 1.50894Z",
    stroke: "url(#paint3_linear_1137_28323)",
    strokeOpacity: 0.1,
    strokeWidth: 0.795755
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1137_28323",
    x1: 26.6825,
    y1: 0.500488,
    x2: 29.6666,
    y2: 16.4155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F83600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#940000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1137_28323",
    x1: 38.6189,
    y1: 4.97659,
    x2: 9.77353,
    y2: 12.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.564103,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.02
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1137_28323",
    x1: 58.1787,
    y1: 0.563477,
    x2: 58.1787,
    y2: 31.2652,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F83600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1137_28323",
    x1: 58.0155,
    y1: 27.357,
    x2: 2.80981,
    y2: 25.8649,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.279686,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.511557,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.52
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagmaLogo);
export default __webpack_public_path__ + "static/media/magmaLogo.b49372354aeae55505675a976dcb827a.svg";
export { ForwardRef as ReactComponent };